import React from 'react'

const React_Coding_Practice_45 = () => {
  return (
    <div>
      <h1>Coding Pratice 45</h1>
    </div>
  )
}

export default React_Coding_Practice_45
